import React from "react";

/**
 * Branded loading screen. It mirrors the splash shipped in public/index.html so
 * the hand-off HTML → React (and auth check → page) is visually seamless.
 */
export function BrandMark({ className = "h-16 w-16" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-hidden="true" className={className}>
      <rect width="64" height="64" rx="14" fill="#0a0a0a" />
      <rect x="12.8" y="18.2" width="19.2" height="7.4" rx="1.6" fill="#f0f0ee" />
      <rect x="23" y="28.3" width="28.2" height="7.4" rx="1.6" fill="#e05236" />
      <rect x="34.6" y="38.4" width="15.4" height="7.4" rx="1.6" fill="#f0f0ee" />
    </svg>
  );
}

export default function AppSplash({ testId = "auth-loading" }) {
  return (
    <div
      data-testid={testId}
      role="status"
      aria-label="FlowGantt"
      className="fixed inset-0 z-[60] flex flex-col items-center justify-center gap-4 bg-white"
    >
      <BrandMark className="h-16 w-16 animate-pulse" />
      <span className="font-display text-[15px] font-black tracking-tighter text-neutral-950">
        FLOWGANTT
      </span>
    </div>
  );
}
